<!-- <p>hierarchy-dashboard works!</p> -->
@if (thisUser && selectedOrganisation && hierarchicalData) {
@if (selectedLocation !='') {

<nav class="navbar-breadcrumb navbar-expand-lg alignRow" id="breadcrumbs">
	@if (breadcrumbItems.length > 0) {
	<ejs-breadcrumb #pageBreadcrumbs [enableNavigation]="false" [items]="breadcrumbItems"
		(itemClick)="onItemClick($event)">
	</ejs-breadcrumb>
	}
	<span class="me-auto"></span>
	<button class="search-button alignRow" (click)="searchForAsset()">
		<span>Search for Asset</span>
		<mat-icon>search</mat-icon>
	</button>
</nav>

<div class="topcontainer">
	@if (hierarchicalLocation) {
	<div class="leftcont">
		<ng-container *ngTemplateOutlet="FuntionalLocations; context: { $implicit: hierarchicalLocation }" />
	</div>
	}
	@if (locationAssets.length > 0) { <div class="rightcont"><ng-container *ngTemplateOutlet="ngAssetTemplate" /></div>
	}
</div>

@if (locationChildren.length > 0) {<ng-container *ngTemplateOutlet="ngSubLocationTemplate" />}

<router-outlet />

}
@else {
<nav class="navbar-breadcrumb navbar-expand-lg alignRow">
	<span>Location cannot be found in {{selectedOrganisation.Name}}. Please check the URL and try again.</span>
	<span class="me-auto"></span>
</nav>
}
}

<!-- Functional Locations View -->
<ng-template #FuntionalLocations let-location>
	@if (location.ParentUid != location.OrganisationUID) {
	<span class="levelBackButton alignRow app-icon--back" (click)="locationSelect(location.ParentUid)">
		<mat-icon matTooltip="Back To Parent Location" />
	</span>
	}
	@if (thisUser.AdminSite && !hideButtons) {
	<span class="newEntryButton app-icon app-icon--add">
		<mat-icon [matMenuTriggerFor]="newEntry" matTooltip="Add New Entry" />
	</span>
	}
	@if (location.Level <= 1) { <div class="hierarchy-imageContainer">
		<img src="{{imagePathOrganisations()}}{{location.Id}}?{{location.Modified}}"
			title="{{location.Name}} - {{location.LocationType}}"
			onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
			[attr.x-contenttype]="'image/png'" />
		</div>
		}
		@if (location.Level > 1) {
		<app-asset-tiles-group [inputSubLocation]="location" [AdminSite]="thisUser.AdminSite"
			(hideButtons)="toggleHideButtons($event)"></app-asset-tiles-group>
		}
</ng-template>

<mat-menu #newEntry="matMenu" [overlapTrigger]="false" yPosition="below">
	<button class="app-icon app-icon--add-asset" mat-menu-item (click)="addAsset(hierarchicalLocation!)">
		<mat-icon /><span>New Asset</span>
	</button>
	<button class="app-icon app-icon--add-location" mat-menu-item (click)="addLocation(hierarchicalLocation!)">
		<mat-icon /><span>New Location</span>
	</button>
</mat-menu>

<ng-template #ngSubLocationTemplate>
	<div class="flex-wrap-locations">
		@for (subLocation of locationChildren; track $index) {
		<div class="ng-location">
			<app-hierarchy-sub-location (selected)="locationSelect($event.Uid)" [child]=subLocation
				[accountID]="accountGUID" [OrganisationID]="OrganisationUID" matTooltip="{{subLocation.Name}}"
				[AdminSite]="thisUser.AdminSite" />
		</div>
		}
	</div>
</ng-template>

<ng-template #ngAssetTemplate>
	@if (locationChildren && hierarchicalLocation) {
	<nav class="assettoolbar alignRow">
		<span>{{locationAssets.length}}&nbsp;Assets in&nbsp;{{hierarchicalLocation.Name}}</span>
		<span class="me-auto"></span>
		<span class="app-icon app-icon--add" (click)="addAsset(hierarchicalLocation!)">
			<mat-icon matTooltip="Add New Asset" />
		</span>
	</nav>
	}
	
	@let sapEnabled = checkFeature(AccountFeatures.SAP);
	<ejs-listview #listviewInstance [dataSource]='locationAssets' [cssClass]='cssClass'>
		<ng-template #template let-dataSource>
			<div class="ejs-listview-item listview-asset" (click)="assetSelect(dataSource)"
				[ngClass]="dataSource.Actioned ? 'actioned' : dataSource.Watch ? 'watchActive' : ''" [ngStyle]="{
					'border': dataSource.AssetID == selectedAsset?.AssetID ? '2px solid var(--prism-blue)' : '',
					'border-radius': dataSource.AssetID == selectedAsset?.AssetID ? 'var(--default-border-radius)' : ''}">
				<img class="assetImage" src="{{imagePathAssets()}}{{dataSource.AssetID}}?{{dataSource.Modified}}"
					onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
					(click)='viewImage(imagePathAssets() + dataSource.AssetID + "?" + dataSource.Modified)'
					[attr.x-contenttype]="'image/png'" />
				<div class="assetDetail">
					<div id="id-name" class="assetName">{{ dataSource.Name}}
						@if ( dataSource.Watch == true){
						<mat-icon style="margin-left: var(--default-margin);">visibility</mat-icon>
						}
					</div>
					<div id="id-description" class="assetInfo">{{dataSource.Description }}</div>
					@if (sapEnabled) {
					<div id="id-info1" class="assetInfo">
						@if (dataSource.FunctionalLocation) {
						<span><b>FL Code</b> - {{dataSource.FunctionalLocation}}&nbsp;</span>
						} @else if (dataSource.ParentFunctionalLocation) {
						<span><b>FL Code</b> - {{dataSource.ParentFunctionalLocation}}&nbsp;</span>
						}

						@if (dataSource.EquipmentCode) {
						<span><b>EQ Code</b> - {{dataSource.EquipmentCode}}&nbsp;</span>
						}
					</div>
					}
				</div>
				<div class="me-auto"></div>
				<div class="alignRow asset-actions">					
					@if (checkIfAssetFlagged(dataSource)) {
					<span class="app-icon app-icon--flagged" matTooltip="Remove from Flagged Assets"
						matTooltipPosition="above">
						<mat-icon (click)="removeFlaggedAsset(dataSource)" />
					</span>
					} @else {
					<span class="app-icon app-icon--add-flagged" matTooltip="Add to Flagged Assets"
						matTooltipPosition="above">
						<mat-icon (click)="addFlagged(dataSource)" />
					</span>
					}
				</div>
			</div>
		</ng-template>
	</ejs-listview>
</ng-template>